import { createContext } from "react";

export const ProyectoContext = createContext();